'use client';

import { DayPicker } from 'react-day-picker';

import styles from './Calendar.module.scss';
import 'react-day-picker/style.css';

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

// assigning SCSS styles to this thing is a pain.
// uncomment the lines below to see the SCSS classNames and react-day-picker classes in the browser console
// https://daypicker.dev/docs/styling#custom-class-names
//
// import('react-day-picker').then((rdp) => {
//   console.log({ myScssStyles: styles });
//   console.log({ rdpDefaultClassNames: rdp.getDefaultClassNames() });
// });

export function Calendar({ showOutsideDays = true, ...props }: CalendarProps) {
  return <DayPicker showOutsideDays={showOutsideDays} classNames={{ ...styles }} {...props} />;
}
